import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';
import {AuthenticationService, Credentials} from '@app/core';
import {CustomerModel} from '../../models/customer.model';

@Injectable()
export class CustomerService {

  public static WYNK_PROVIDER = 'Wynk';
  public static FACEBOOK_PROVIDER = 'Facebook';
  public static GOOGLE_PROVIDER = 'Google';

  public URL_PRE_REGISTER = '/user/pre-register';
  public URL_EMAIL = '/user/register-email';
  public URL_CONFIRM_CODE = '/user/confirmcode';
  public URL_FORGOT_PASSWORD = '/account/forgotpassword';
  public URL_LOTERY_BSB = '/nf/lotery/bsbshopping';

  constructor(private http: Http) { }

  preRegister(
    customer: CustomerModel,
    password: string,
    cpf: string,
    provider: string,
    token: string ): Observable<Credentials> {
    const encodString = btoa(this.parseCpf(cpf) + ':' + password);
    console.log(cpf + ' - ' + password);

    const options = this.getOptions(provider);

    if (provider === CustomerService.WYNK_PROVIDER) {
      options.headers.append('authorization', 'Basic ' + encodString);
    } else {
      options.headers.append('token', token );
      customer.cpf = this.parseCpf(cpf);

    }

    return this.http.post(this.URL_PRE_REGISTER, customer, options)
      .pipe(
        map((res: Response) => {
          return res.json();
        })
      );
  }

  forgotPassword(email: string) {
    const provider = this.getOptions();
    return this.http.post(this.URL_FORGOT_PASSWORD, { email: email }, provider)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, cannot send recover e-mail'))
      );
  }

  lotery(): Observable<any> {

    return this.http.get(this.URL_LOTERY_BSB)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load PROMOTIONS'))
      );

  }

  sendEmail(credentials: Credentials): Observable<any> {

    return this.http.get(this.URL_EMAIL)
      .pipe(
        map((res: Response) => {
          return res;
        }),
        catchError(() => of('Error, could not register user'))
      );
  }


  parseCpf(value: string): string {
    value = value.replace( /\D/g , '');
    value = value.replace( /(\d{3})(\d)/ , '$1.$2');
    value = value.replace( /(\d{3})(\d)/ , '$1.$2');
    value = value.replace( /(\d{3})(\d{1,2})$/ , '$1-$2');
    return value;

  }

  private getOptions(provider: string = null): RequestOptions {
    const options = new RequestOptions();
    options.headers = new Headers();
    if (provider) {
      options.headers.append('provider', provider);
    }
    options.headers.append('Content-Type', 'application/json');
    return options;
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/customer/customer.service.ts